import { defineComponent as _defineComponent } from 'vue'
import Ribbon from '@/core/ribbon/ribbon.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {


return { __sfc: true,Ribbon }
}

})